import loadable from '@loadable/component';
import {
  COMPONENT_CURATED,
  COMPONENT_NOTFOUND,
  COMPONENT_DASHBOARD,
  COMPONENT_LIST,
  MAINTENANCE_MODE,
  COMPONENT_CATALOG,
  COMPONENT_TUTORIAL,
  COMPONENT_UNIT_WRAPPER,
  COMPONENT_MODULE_UNIT_WRAPPER,
  COMPONENT_CURATED_TUTORIAL,
  COMPONENT_LIVE_CLASS_ENROLLMENT,
  COMPONENT_COACHING_REQUEST,
  COMPONENT_COLLECTION,
  APP_PROBLEM_EDITOR,
  COMPONENT_INDEX,
} from './constants';

const importMap = {};

/* Enable Async module loading and code splitting for client */
importMap[COMPONENT_CURATED] = loadable(() => import(/* webpackChunkName: "curated" */'../pageTypes/curated'));
importMap[COMPONENT_INDEX] = loadable(() => import(/* webpackChunkName: "index" */'../pageTypes/index'));
importMap[COMPONENT_NOTFOUND] = loadable(() => import(/* webpackChunkName: "notFound" */'../pageTypes/notFound'));
importMap[COMPONENT_DASHBOARD] = loadable(() => import(/* webpackChunkName: "userProfile" */'../pageTypes/dashboard'));
importMap[COMPONENT_COLLECTION] = loadable(() => import(/* webpackChunkName: "userProfile" */'../pageTypes/collection'));
importMap[COMPONENT_LIST] = loadable(() => import(/* webpackChunkName: "list" */'../pageTypes/list'));
importMap[MAINTENANCE_MODE] = loadable(() => import(/* webpackChunkName: "maintenanceMode" */'../pageTypes/maintenanceMode'));
importMap[COMPONENT_CATALOG] = loadable(() => import(/* webpackChunkName: "learnCatalog" */'../pageTypes/catalog'));
importMap[COMPONENT_TUTORIAL] = loadable(() => import(/* webpackChunkName: "tutorial" */'../pageTypes/tutorial'));
importMap[COMPONENT_UNIT_WRAPPER] = loadable(() => import(/* webpackChunkName: "tutorial" */'../pageTypes/unitWrapper'));
importMap[COMPONENT_CURATED_TUTORIAL] = loadable(() => import(/* webpackChunkName: "curatedTutorial" */'../pageTypes/curatedTutorial'));
importMap[COMPONENT_LIVE_CLASS_ENROLLMENT] = loadable(() => import(/* webpackChunkName: "enrollment" */'../pageTypes/enrollment'));
importMap[COMPONENT_COACHING_REQUEST] = loadable(() => import(/* webpackChunkName: "coachingRequest" */'../pageTypes/coachingRequest'));
importMap[COMPONENT_MODULE_UNIT_WRAPPER] = loadable(() => import(/* webpackChunkName: "moduleUnitWrapper" */'../pageTypes/moduleUnitWrapper'));
importMap[APP_PROBLEM_EDITOR] = loadable(() => import(/* webpackChunkName: "problemEditor" */'../../contentfulApps/problemEditor/index'));

export default importMap;
